

































import { Component } from 'vue-property-decorator';

import SectionWrapper from '@/componentsV2/molecules/SectionWrapper/SectionWrapper.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';
import PerformanceActivitiesTotalSpend from '@/componentsV2/templates/PerformanceActivitiesTotalSpend/PerformanceActivitiesTotalSpend.vue';
import PerformanceActivitiesOverview from '@/componentsV2/templates/PerformanceActivitiesOverview/PerformanceActivitiesOverview.vue';
import PerformanceActivitiesList from '@/componentsV2/templates/PerformanceActivitiesList/PerformanceActivitiesList.vue';
import BannerActivateBilling from '@/components/molecules/BannerActivateBilling/BannerActivateBilling.vue';

import { EBusinessReportType } from '@/models/business';
import BillingModel from '@/views/Models/BillingModel.vue';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';

@Component({
  components: {
    SectionWrapper,
    Page,
    PerformanceActivitiesTotalSpend,
    PerformanceActivitiesOverview,
    PerformanceActivitiesList,
    BannerActivateBilling
  }
})
export default class Activities extends BillingModel {
  get tPrefix() {
    return 'performance.activities.overview';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get showTotalSpend() {
    return this.businessInfo.reportType !== EBusinessReportType.OFFER;
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get tPrefixBilling() {
    return 'performance.billing';
  }

  get showActivateBillingBanner() {
    return this.billingStatus === EBillingStatusTypes.UNSUBSCRIBED;
  }

  get descriptionActivateBilling() {
    return this.$t(`${this.tPrefixBilling}.bannerDescription`);
  }

  mounted() {
    if (
      window.previousRouteName &&
      window.previousRouteName === 'performance-customer-center-detail'
    ) {
      this.setScrollPosition();

      return;
    }

    this.$store.dispatch('performance/RESET_CONFIG', {
      context: 'activity'
    });
  }

  setScrollPosition() {
    const containerScrollElement = document.querySelector(
      '.container-scrollable'
    );

    const scrollYPos = this.$store.getters['performance/getActivityState']
      .config.scrollYPos;

    if (containerScrollElement) {
      containerScrollElement.scrollTo({
        top: scrollYPos,
        left: 0
      });
    }
  }
}
